import React from "react";
import Routes from "./routes";
import { store } from "./shared";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { AppointmentProvider } from "./context/AppointmentContext";
const App = () => {
  return (
    <AppointmentProvider>
      <ConfigProvider
        theme={{
          token: {
            // Seed Token
            colorPrimary: "rgb(127, 182, 145)",
          },
        }}
      >
        <Provider store={store}>
          <Routes />
        </Provider>
      </ConfigProvider>
    </AppointmentProvider>
  );
};

export default App;
